import axiosPrivate from "../hooks/useAxiosPrivate";

const URL= '/ova'

const obtenerOvas = async () => {
    try {
        const response = await axiosPrivate.get(URL,
            );
        //console.log(response);
        return response?.data;
    } catch (error) {
        //console.log(error.response);
        throw new Error(error.response.data.error);
    }
};

const obtenerOva = async (_id) => {
    try {
        const response = await axiosPrivate.get(`${URL}/${_id}`);
        //console.log(response);
        return response?.data;
    } catch (error) {
        //console.log(error.response);
        throw new Error(error.response.data.error);
    }
};

const OvaService={
    obtenerOvas,
    obtenerOva,
}

export default OvaService;
